<template>
  <div id="app">
    <v-app>
      <div class="ma-4" style="display: flex">
        <div style="width: 200px" class="mr-2">
          <settings ref="settings"></settings>
          <v-layout class="justify-lg-space-between">
            <v-btn @click="onCreate">Create</v-btn>
            <v-btn @click="onReset">Reset</v-btn>
          </v-layout>
        </div>
        <div class="checker-board" style="flex: 1 1 0">
          <window-manager ref="WindowManager" width="100%" :height="500" dark> </window-manager>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import Settings from './Settings.vue';

import WindowA from './components/WindowA.vue';
import WindowB from './components/WindowB.vue';

export default {
  name: 'App',
  components: { Settings },
  mounted() {},
  methods: {
    onCreate() {
      const settings = this.$refs.settings.getSettings();
      const newOptions = Object.assign({}, WindowA['mdi-options'], {
        mode: 'resizable',
        labels: {
          title: settings.title,
        },
        initPos: { x: settings.initX, y: settings.initY },
        initSize: { w: settings.width, h: settings.height },
      });

      const component = Object.assign({}, WindowA, {
        'mdi-options': newOptions,
      });
      this.$refs.WindowManager.createNewWindow(component);
    },
    onReset() {
      this.$refs.WindowManager.reset();
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.debug-r {
  border: 1px solid red;
}

.checker-board {
  background: repeating-conic-gradient(#fff 0deg 90deg, rgb(216, 216, 216) 0 180deg) 0 0/5% 10%;
}
</style>
